import { createEmailSignaturePreference } from './createEmailSignaturePreference';
import { ErrorCodes } from 'mini-sds-gateway';
import { extractEmailSignatureItem } from '../utils/extractEmailSignatureItem';
import { getBXUserCustomPropertiesItems } from './getBXUserCustomPropertiesItems';
import type { EmailSignatureItemResponse } from '../schema/EmailSignatureResponse';

export async function ensureEmailSignaturePreferenceIsPresent(): Promise<EmailSignatureItemResponse> {
    // try to fetch the collection items
    const itemsResponse = await getBXUserCustomPropertiesItems();

    let emailSignaturePreferenceResponse: EmailSignatureItemResponse;
    const defaultEmailSignaturePreference = { UseDesktopSignature: true };

    if (itemsResponse?.value) {
        const emailSignatureItem = extractEmailSignatureItem(itemsResponse.value);

        if (emailSignatureItem) {
            return emailSignatureItem;
        }
        return createEmailSignaturePreference(defaultEmailSignaturePreference);
    }

    // Handle the case where the collection itself is not created yet
    if (itemsResponse?.error) {
        if (itemsResponse?.error.code === ErrorCodes.CollectionIdNotFound) {
            // create both collection and item
            emailSignaturePreferenceResponse = await createEmailSignaturePreference(
                defaultEmailSignaturePreference,
                { createCollection: true }
            );
        }
    }

    return emailSignaturePreferenceResponse;
}
